import { RequestCommonParams, handleRequestError } from '@jove-frontend/uikit';
import { api } from '@jove-frontend/uikit';

// get user info
export const apiGetUserBasicInfo = async (payload: { id: string } & RequestCommonParams) => {
  try {
    const res = await api.get(`/users/${payload.id}`);
    return [res.data];
  } catch (err) {
    return handleRequestError(err, payload);
  }
};

// update user basic info
export const apiUpdateUserBasicInfo = async (payload: { id: string } & RequestCommonParams) => {
  try {
    const res = await api.patch(`/users/${payload.id}`, payload);
    return [res.data];
  } catch (err) {
    return handleRequestError(err, payload);
  }
};

// change passsword
export const apiChangePassword = async (payload: RequestCommonParams) => {
  try {
    const res = await api.post(`/users/reset_password`);
    return [res.data];
  } catch (err) {
    return handleRequestError(err, payload);
  }
};
